import React from 'react';

import IconBtn from '../../../modules/icon-btn/icon-btn';

import PlusIcon from './plus-icon.svg';

import './orders-bottom.scss';

interface OrdersBottomProps {
  onClick: () => void;
}

const OrdersBottom: React.FC<OrdersBottomProps> = ({ onClick }) => (
  <div className="orders__footer">
    <IconBtn
      onClick={onClick}
      title="Загрузить еще реестры"
      icon={PlusIcon}
      className="btn--sm btn--outline"
    />
  </div>
);

export default OrdersBottom;
